import React from 'react';
import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Link from 'next/link';
import AppCustomLink from '../Common/AppCustomLink';
import VisibilitySensor from 'react-visibility-sensor';
import { spacing, fixedSpacing, maxScreenSize, minImageWidth } from '../../lib/theme';
import {
  getPodcastImgSize, convertToSlug, isLocalStoragePresent, cleanText, cleanGenres,
  podcastSlugUrl, podcastHrefUrl, setCurrentPodcastData,
  bookImage,
  isNews,
  stringToDateDay
} from '../../lib/utils';

// import { Tooltip } from 'antd';
import SubscribeOption from './SubscribeOption';
import PodcastBadge from './PodcastBadge';
import { logAdClick, logAdImpression } from '../../actions';
import { Button } from 'antd';
import { logClickToElastic } from '../../lib/searchItunes';

class Podcast extends React.Component {
  // loadPage = () => {
  //   message.loading('Loading...', 0);
  //   // Dismiss manually and asynchronously
  //   // setTimeout(hide, 2500);
  // }

  // componentWillUnmount() {
  //   message.destroy();
  // }

  saveSearchBool = (podcast) => {
    const { fromSearch } = this.props;
    const fromSearchBool = fromSearch ? true : false;
    if (!fromSearchBool) {
      setCurrentPodcastData(podcast);
    }
    const podcastFeedUrl = podcast.feedUrl && podcast.feedUrl.split('?limit')[0];
    if (fromSearchBool) {
      console.dir('in searchBool');
      const searchBool = { feedUrl: podcastFeedUrl, time: new Date().getTime() };
      isLocalStoragePresent() && localStorage.setItem('lastSearchBool', JSON.stringify(searchBool));
    }
  }

  onVisibleChange = (isVisible) => {
    console.log('Element is now %s', isVisible ? 'visible' : 'hidden');
    const { adGenreId, podcast, parentAd } = this.props;
    if (isVisible) {
      logAdImpression(adGenreId, podcast.collectionId, parentAd);
    }
  }

  onClickPod = () => {
    const { adGenreId, podcast, parentAd } = this.props;
    logAdClick(adGenreId, podcast.collectionId, parentAd);
    if (parentAd && parentAd.startsWith('Search-')) {
      logClickToElastic(podcast.collectionId);
    }
  }

  // const podcast = (props) => {
  render() {
    const { podcast, showSubscribe, size, showArtistName, showEpisodeCount,
      marginBottom, showGenres, showBadge, forceSquare, showViewButton } = this.props;
    const { borderColor, mainLayoutColor } = this.props.settingsState;
    const podcastId = podcast.id || podcast.collectionId;

    const itunesRawId = podcast.collectionId || '';
    // console.dir(podcast.feedUrl);
    // console.dir(podcastFeedUrl);
    let cleanedGenres = cleanGenres(podcast.genres);
    let genres = cleanedGenres.join(', ');
    const mainDiv = <div className='post-item'>
      <AppCustomLink href={podcastHrefUrl(itunesRawId)} as={podcastSlugUrl(podcast.collectionName, itunesRawId)}>
        <a onClick={this.onClickPod} onMouseDown={this.saveSearchBool.bind(this, podcast)} style={{}}>
          {/* <div className='post-item' onClick={this.props.onClick}> */}
          {showBadge && <PodcastBadge collectionId={`${podcast.collectionId}`} />}
          <img src={bookImage(podcast)} alt={`${podcast.collectionName || ''} book`} />
          <div className='news-icon'>
            {isNews(podcast) && stringToDateDay(podcast.releaseDate)}
          </div>

          <div className='details'>
            {/* <Tooltip title={podcast.collectionName}> */}
            <h5 className='title'>{isNews(podcast) ? stringToDateDay(podcast.releaseDate) : podcast.collectionName}</h5>
            {/* </Tooltip> */}
            {/* <Tooltip title={podcast.artistName}> */}
            {showArtistName && <h5 style={{ color: 'gray', textAlign: 'left', opacity: '0.5' }} className='name'>{podcast.artistName}</h5>}
            {/* {showEpisodeCount && <h5 style={{ color: 'gray', textAlign: 'left', marginBottom: '2px' }} className=''>~{podcast.trackCount || '-'} Episodes</h5>} */}
            {/* </Tooltip> */}
            {/* {podcast.primaryGenreName} */}
            {/* {podcast.trackCount && <span>Episodes - {podcast.trackCount}
              <br /></span>} */}
            {/* {showSubscribe && userDetails && !subscribed && <Button onClick={(event) => { this.onSubscribeClick(event, userDetails.uid, podcast) }}>SUBSCRIBE</Button>}
              {showSubscribe && userDetails && subscribed && */}
            {showGenres && <p className='genres' style={{ fontSize: '12px', textAlign: 'left' }}>{genres}</p>}
            {/* Tags - {podcast.genres !== undefined ? podcast.genres.map((genre) => (
          <p> {genre} </p>
        )) : ''} */}
            {showViewButton && <Button>View Summary</Button>}
          </div>
        </a>
      </AppCustomLink>
      {podcast.showAd && <div className='ads-show-div'>Ad</div>}
      <div style={{ position: 'relative' }}>
        {/* {showSubscribe && <div style={{
          position: 'absolute', right: '0',
          bottom: `${(showGenres ? 1 : 0) + (showEpisodeCount ? 2.5 : 0) + (showArtistName ? 5 : 2.5)}` + 'em'
        }}>
          <SubscribeOption itunesId={podcastId} podcast={podcast} showSubscribers={false} />
        </div>} */}
      </div>
      <style jsx>
        {`
            .ads-show-div {
              padding: 0 4px;
              background: orange;
              position: absolute;
              right: 0;
              top: 0;
              border-radius: 2px;
              font-size: 10px;
            }
            .news-icon {
              position: absolute;
              top: 6px;
              right: 8px;
              font-size: 12px;
              font-weight: bold;
              color: darkblue;
            }
            img {
              width: 100%;
              min-height: ${size === 'lg' ? '160px' : '120px'}; // so that images load better.
              // max-height: ${forceSquare ? '120px' : '160px'}; // so that images load better.
              min-width: ${minImageWidth};
              border-radius: ${spacing('md')};
              // box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
              box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
            }
           .post-item{
              position: relative;
              flex: 0 0 ${size === 'lg' ? '12em' : '7.5em'};
              // min-width: ${size !== 'lg' && '90px'}; // 80px;
              width: ${size != 'lg' && '100px'};
              cursor: pointer;
              display: inline-block;
              width: ${size === 'md' ? '120px' : '160px'};
              // max-width: 420px;
              // margin-right: calc(${size === 'lg' ? 2.5 : 3.5} * ${fixedSpacing()});
              margin-bottom: ${marginBottom || '2rem'};
              background: ${mainLayoutColor}; // white;
              // flex-basis: 15%;
           }
           @media ${maxScreenSize.laptop} {
             img{
                 width: 10vw;
                  min-height: 120px; // so that images load better.
                  border-radius: ${spacing('xs')};
             }
             .post-item{
                // margin-right: 0;
                max-width: 120px;
             }
           }
           .details {
              max-width: 160px;
              text-align: center;
            //  padding-left: ${spacing('md')};
           }
           .title {
             text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 180px;
              margin-top: ${spacing('')};
           }
           .name {
              max-width: 180px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              line-height: 18px;     /* fallback */
              height: 36px;      /* fallback */
              -webkit-line-clamp: 2; /* number of lines to show */
              -webkit-box-orient: vertical;
           }
           .genres {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
           }
        `}
      </style>
    </div>
    if (podcast['isAd']) {
      return (
        <VisibilitySensor onChange={this.onVisibleChange}>
          {mainDiv}
        </VisibilitySensor>
      )
    } else {
      return (
        mainDiv
      )
    }
  }
}
Podcast.defaultProps = {
  size: 'md',
  showArtistName: false,
  showEpisodeCount: false,
  showGenres: false,
  showSubscribe: true,
  forceSquare: true,
  showViewButton: false,
  showBadge: false
}

Podcast.propTypes = {
  // userDetails: PropTypes.object,
  podcast: PropTypes.object,
  marginBottom: PropTypes.any,
  settingsState: PropTypes.object,
  showSubscribe: PropTypes.bool,
  forceSquare: PropTypes.bool,
  fromSearch: PropTypes.bool,
  showArtistName: PropTypes.bool,
  showEpisodeCount: PropTypes.bool,
  showGenres: PropTypes.bool,
  showBadge: PropTypes.bool,
  showViewButton: PropTypes.bool,
  size: PropTypes.string,
  adGenreId: PropTypes.string,
  parentAd: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    settingsState: state.settingsState,
  }
}

export default connect(mapStateToProps, null)(Podcast)